import type * as Types from '../../../__generated__/bffGlobalTypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetReferralDashboardDataVariables = Types.Exact<{ [key: string]: never; }>;


export type GetReferralDashboardData = {
  organization: {
    __typename?: 'Organization',
    referralUrl: string,
    partnershipType: string,
    inPartnerBuyerLeadPilot: boolean
  } | null
};


export const GetReferralDashboardDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReferralDashboardData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralUrl"}},{"kind":"Field","name":{"kind":"Name","value":"partnershipType"}},{"kind":"Field","name":{"kind":"Name","value":"inPartnerBuyerLeadPilot"}}]}}]}}]} as unknown as DocumentNode<GetReferralDashboardData, GetReferralDashboardDataVariables>;